import { Body, H1 } from 'components/Typography';
import DefaultStatus from 'components/Status';
import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { Form as FormikForm } from 'formik';

/* eslint-disable import/prefer-default-export */
// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(35, 35, 35, 0.02),
    0rem 0.5rem 2rem rgba(35, 35, 35, 0.02);
  border-radius: 1.5rem;
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H1)`
  font-weight: 700;
  margin-bottom: 1rem;
`;

export const SpanRight = styled.span`
  float: right;
  color: ${({ theme }) => theme.colors.gray5};
`;

// TODO: TFR-44 move to container group
export const Content = styled.div`
  width: 100%;
  padding: 0 1.5rem;
  height: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  cursor: pointer;
  border-radius: 1rem;
`;

// TODO: TFR-44 move to container group
export const Row = styled.div`
  height: 4.5rem;
  padding: 0.25rem 0.5rem;
  height: 4.5rem;
  cursor: pointer;

  &:hover {
    ${Content} {
      background-color: ${({ theme }) => theme.colors.gray1};
    }
  }
`;

// TODO: TFR-44 move to typography group
export const Day = styled(Body)`
  font-weight: 600;
`;

// TODO: TFR-44 move to container group
export const Status = styled.div`
  display: flex;
  align-items: center;
`;

// TODO: TFR-44 move to container group

export const Timing = styled.div`
  display: flex;
  align-items: center;
`;

// TODO: TFR-44 move to typography group
export const Time = styled(Body)`
  color: ${({ theme }) => theme.colors.gray6};
  :first-child {
    margin-right: 2.5rem;
  }
`;

// TODO: TFR-44 move to DefaultStatus
export const StatusCircle = styled(DefaultStatus)`
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.75rem;
`;

// TODO: TFR-44 move to typography group
export const StatusText = styled(Body)`
  margin-right: 0.5625rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Form = styled(FormikForm)``;
